<!-- eslint-disable prettier/prettier -->
<mat-card appearance="outlined">
	<div class="m-5">
		<!-- <mat-card-header>
			<mat-card-title class="form-title">
				<h2>Completá tus datos de contacto</h2>
			</mat-card-title>
		</mat-card-header> -->

		<mat-card-content>
			<p class="form-subtitle">
				Usaremos estos datos para comunicarnos con vos y para que puedas acceder a tu
				cuenta.
			</p>

			@if (errorMessage()) {
			<div class="access-error-banner">
				<lucide-icon
					name="circle-alert"
					[size]="24"
					[strokeWidth]="2"
					color="#131416"
				></lucide-icon>
				<span>{{ errorMessage() }}</span>
			</div>
			}

			<form [formGroup]="accessForm" class="grid grid-cols-1 gap-6 md:grid-cols-2">
				<!-- Email -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Email</mat-label>
						<input
							matInput
							type="email"
							placeholder="juanperez@gmail.com"
							formControlName="email"
						/>
					</mat-form-field>
					<mat-error>
						@if (accessForm.get('email')?.touched) { {{ accessForm.get('email')!.errors |
						formErrors }} }
					</mat-error>
				</div>

				<!-- Confirmá tu email -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Confirmá tu email</mat-label>
						<input
							matInput
							type="email"
							placeholder="juanperez@gmail.com"
							formControlName="confirmEmail"
						/>
					</mat-form-field>
					@if (emailsMismatch) {
					<mat-error>Los emails no coinciden</mat-error>
					} @else {
					<mat-error>
						@if (accessForm.get('confirmEmail')?.touched) { {{
						accessForm.get('confirmEmail')!.errors | formErrors }} }
					</mat-error>
					}
				</div>

				<!-- Celular -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Teléfono celular</mat-label>
						<input
							matInput
							type="tel"
							placeholder="1112345678"
							formControlName="celular"
						/>
					</mat-form-field>
					<mat-error>
						@if (accessForm.get('celular')?.touched) { {{
						accessForm.get('celular')!.errors | formErrors }} }
					</mat-error>
				</div>

				<!-- Teléfono fijo -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Teléfono fijo (opcional)</mat-label>
						<input
							matInput
							type="tel"
							placeholder="1145678901"
							formControlName="telefono"
						/>
					</mat-form-field>
					<mat-error>
						@if (accessForm.get('telefono')?.touched) { {{
						accessForm.get('telefono')!.errors | formErrors }} }
					</mat-error>
				</div>

				<!-- Captcha placeholder -->
				<!-- <div class="captcha-placeholder md:col-span-2">
					<span>[ reCAPTCHA — pendiente de integración ]</span>
				</div> -->

				<!-- Términos y condiciones -->
				<div class="terms-container md:col-span-2">
					<mat-checkbox formControlName="terminosAceptados" color="primary">
						<span class="terms-label">
							Declaro que los datos ingresados son verdaderos y acepto los
							<a
								href="#"
								class="terms-link"
								(click)="$event.stopPropagation(); $event.preventDefault(); openTerminos()"
								>Términos de Uso y Políticas de Privacidad</a
							>

							de Identidad Digital VL.
						</span>
					</mat-checkbox>
					@if (accessForm.get('terminosAceptados')?.touched &&
					accessForm.get('terminosAceptados')?.invalid) {
					<mat-error class="terms-error"
						>Debés aceptar los términos y condiciones</mat-error
					>
					}
				</div>
			</form>
		</mat-card-content>
	</div>
</mat-card>
